import React from 'react';

import UserPresenter from '../../../../presenters/UserPresenter';

import UserCell from './components/UserCell';

const UsersTable = (props) => {
  const { users } = props;
  return (
    <table className="tables">
      <thead>
        <tr>
          <th>Auth0 Id</th>
          <th>Full Name</th>
          <th>Email</th>
          <th>Membership State</th>
          <th>Birthdate</th>
          <th>Gender</th>
          <th>Phone Number</th>
          <th>Created At</th>
          <th>FastCash</th>
        </tr>
      </thead>
      <tbody>
        {users.map((user) => (
          <UserCell key={UserPresenter.id(user)} user={user} />
        ))}
      </tbody>
    </table>
  );
};

export default UsersTable;
